import { defineMessages } from 'react-intl';

export const scope = 'app.components.transactions';

export default defineMessages({
  empty_transactions: {
    id: `${scope}.empty_transactions`,
    defaultMessage: 'Financial Transactions Will Appear Here',
  },
  empty_record_title: {
    id: `${scope}.empty_search_list`,
    defaultMessage: 'No Results Found',
  },
  empty_record_description: {
    id: `${scope}.empty_record_description`,
    defaultMessage: "We couldn't find anything that matches your criteria. Try refining your filters.",
  },
  download_list: {
    id: `${scope}.download_list`,
    defaultMessage: 'Download List',
  },
});
